module.exports = __webpack_public_path__ + "img/win-s2-3.f8c6614d.png";